$(document).ready(function() {
    initModalEvents();
});